import * as React from 'react'
import {experimental, hasFeatureFlag} from 'yougile-util'
import {CollapsedHeaderCheckbox} from './collapsed-header-checkbox'

export const ExperimentalFeatures = () => {
  if (!hasFeatureFlag(experimental)) {
    return null
  }

  return <CollapsedHeaderCheckbox />
}
